import { render, staticRenderFns } from "./subject.vue?vue&type=template&id=7bb64e86&scoped=true"
import script from "./subject.vue?vue&type=script&lang=js"
export * from "./subject.vue?vue&type=script&lang=js"
import style0 from "./subject.vue?vue&type=style&index=0&id=7bb64e86&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb64e86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\App_php\\cqjtdx\\cqjtdx_student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bb64e86')) {
      api.createRecord('7bb64e86', component.options)
    } else {
      api.reload('7bb64e86', component.options)
    }
    module.hot.accept("./subject.vue?vue&type=template&id=7bb64e86&scoped=true", function () {
      api.rerender('7bb64e86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/course/subject.vue"
export default component.exports